import { createSelector } from 'reselect';
import PredesPlannedTransportAnomaliesDestinationDetailsColumns
  from '../../containers/PredesPlannedTransportAnomaliesDestinationDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesPlannedTransportAnomaliesDestinationDetailsColumns);
